// extracted by mini-css-extract-plugin
export default {"wrap":"Dots_wrap__NQdG3","dot":"Dots_dot__eM-b4","fade":"Dots_fade__8TqcG"};